import React, { useState } from 'react';

import './dropdown.multiselect.scss';
import ButtonIcon from "../buttons/Button.icon";

function DropdownMultiSelect({options, label, items, onChange}){
    const [isOpen, setOpen] = useState(false);
    const _items = items? items : [];

    const isSelected = (value) => {
        return _items.filter((v) => v === value).length !== 0;
    }

    const toggleOpen = () => {
        setOpen(!isOpen);
    }

    const _onChange = (option) => {
        return () => {
            const index = _items.indexOf(option.value);
            if (index !== -1) {
                _items.splice(index, 1);
            } else {
                _items.push(option.value);
            }
            onChange(JSON.parse(JSON.stringify(_items)));
        }
    }

    return (
        <div className={`_dropdownMultiSelectContainer ${isOpen ? 'open' : ''}`}>
            {
                isOpen ? <div className="_dropdownOverlay" onClick={toggleOpen}></div> : ''
            }
            <div className="actionButton" onClick={toggleOpen}>
                <ButtonIcon size={34}>
                    <span className="material-icons">
                        add
                        </span>
                </ButtonIcon>
                <p>Add parameter</p>
            </div>
            <div className="_options">
                {
                    label ?
                    <p className="label">{label}</p>
                    : ''
                }
                {
                    options.map((option, index) => {
                        const selected = isSelected(option.value);
                        return (
                            <div className={`_option ${selected ? 'selected' : ''}`} onClick={_onChange(option)} key={index}>
                                <div className="check">
                                    <i className="material-icons">
                                        check
                                    </i>
                                </div>
                                <p>
                                    {option.label}
                                </p>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default DropdownMultiSelect;